<template>
    <a @click="toggleFavorite()">
        {{ this.isFavorite ? this.removeFromFavoriteLabel : this.addToFavoriteLabel }}
    </a>
</template>

<script>
    export default {
        props: {
            subscription: String,
            initialIsFavorite: Boolean,
            addToFavoriteLabel: String,
            removeFromFavoriteLabel: String,
            route: String,
            setFavoriteHandler: Function,
        },
        data: function () {
            return {
                isFavorite: this.initialIsFavorite
            }
        },
        methods: {
            setFavorite() {
                this.setFavoriteHandler(this.subscription, this.isFavorite);
            },
            toggleFavorite() {
                if(this.route){
                    axios.post(this.route, {
                            'subscription' : this.subscription
                        }
                    ).then( (response) => {
                        this.isFavorite = response.data.is_favorite;
                        this.setFavorite();
                    }).catch(function (error) {
                        // error management?
                        console.log(error);
                    });
                }
            }
        },
        mounted: function() {
            this.setFavorite()
        }
    };
</script>
